import ReduxHelper from 'lib/ReduxHelper';

export const GT_ESTIMATE_ACTION_TYPES = {
  GT_ESTIMATE_FETCH_DATA: 'GT_ESTIMATE_FETCH_DATA',
  GT_ESTIMATE_FETCH_DATA_SUCCESS: 'GT_ESTIMATE_FETCH_DATA_SUCCESS',
  GT_ESTIMATE_FETCH_DATA_FAIL: 'GT_ESTIMATE_FETCH_DATA_FAIL',
  GT_ESTIMATE_FETCH_CLEAR_DATA: 'GT_ESTIMATE_FETCH_CLEAR_DATA',

  GT_ESTIMATE_RERUN_DATA: 'GT_ESTIMATE_RERUN_DATA',
  GT_ESTIMATE_RERUN_DATA_SUCCESS: 'GT_ESTIMATE_RERUN_DATA_SUCCESS',
  GT_ESTIMATE_RERUN_DATA_FAIL: 'GT_ESTIMATE_RERUN_DATA_FAIL',
  GT_ESTIMATE_RERUN_CLEAR_DATA: 'GT_ESTIMATE_RERUN_CLEAR_DATA',

  GT_ESTIMATE_UPDATE_DATA: 'GT_ESTIMATE_UPDATE_DATA',
  GT_ESTIMATE_UPDATE_DATA_SUCCESS: 'GT_ESTIMATE_UPDATE_DATA_SUCCESS',
  GT_ESTIMATE_UPDATE_DATA_FAIL: 'GT_ESTIMATE_UPDATE_DATA_FAIL',
  GT_ESTIMATE_UPDATE_CLEAR_DATA: 'GT_ESTIMATE_UPDATE_CLEAR_DATA',

  GT_ESTIMATE_RESET_PROCESSING: 'GT_ESTIMATE_RESET_PROCESSING',
  GT_ESTIMATE_RESET_PROCESSING_SUCCESS: 'GT_ESTIMATE_RESET_PROCESSING_SUCCESS',
  GT_ESTIMATE_RESET_PROCESSING_FAIL: 'GT_ESTIMATE_RESET_PROCESSING_FAIL',
  GT_ESTIMATE_RESET_PROCESSING_CLEAR: 'GT_ESTIMATE_RESET_PROCESSING_CLEAR',

  GT_ESTIMATE_DELETE_DATA: 'GT_ESTIMATE_DELETE_DATA',
  GT_ESTIMATE_DELETE_DATA_SUCCESS: 'GT_ESTIMATE_DELETE_DATA_SUCCESS',
  GT_ESTIMATE_DELETE_DATA_FAIL: 'GT_ESTIMATE_DELETE_DATA_FAIL',
  GT_ESTIMATE_DELETE_CLEAR_DATA: 'GT_ESTIMATE_DELETE_CLEAR_DATA',
};

export const fetchGTEstimateData = insuranceID =>
  ReduxHelper.createAction(GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_FETCH_DATA, {
    insuranceID,
  });

export const clearGTEstimateData = () =>
  ReduxHelper.createAction(GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_CLEAR_DATA);

export const deleteEstimations = estimationIDs =>
  ReduxHelper.createAction(GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_DELETE_DATA, {
    estimationIDs,
  });

export const updateEstimations = (dateFrom, dateTo, insuranceId) =>
  ReduxHelper.createAction(GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_UPDATE_DATA, {
    dateFrom,
    dateTo,
    insuranceId,
  });

export const resetProcessing = insuranceID =>
  ReduxHelper.createAction(
    GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_RESET_PROCESSING,
    { insuranceID }
  );

export const rerunGTEstimateData = (
  estimations,
  forceRun,
  allFailed,
  allPending,
  insuranceId,
  dateFrom,
  dateTo
) =>
  ReduxHelper.createAction(GT_ESTIMATE_ACTION_TYPES.GT_ESTIMATE_RERUN_DATA, {
    estimations,
    forceRun,
    allFailed,
    allPending,
    insuranceId,
    dateFrom,
    dateTo,
  });
